//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { ShareRoutes } from '@share/constants/shareConstants';
import { IUrlRouterProvider } from 'angular-ui-router';
import { crl8 } from 'app/curalate.globals';
import {
  componentNameToTemplate,
  hasAllFeatures,
  hasFeature,
  lazyLoadModule,
  NavGroup,
  StateFactory,
} from 'app/initialization/routing/stateHelpers';

export function routingRules(urlRouterProvider: IUrlRouterProvider) {
  urlRouterProvider.when('/share2', '/connect');
  urlRouterProvider.when('/share2/*path', '/connect/{path}');
}

export const states = {
  [ShareRoutes.MAIN]: StateFactory({
    url: '/connect',
    template: componentNameToTemplate('sharePage'),
    data: {
      title: 'Connect',
      navGroup: NavGroup.MEDIA,
      hasAccess: () => hasAllFeatures('share_v2') || !!crl8.session?.client.isShareV2Vendor,
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.share',
        () => import('app/share/ShareApp'),
      ),
    },
  }),

  [ShareRoutes.HASHTAGS_USAGE]: StateFactory({
    url: '/connect/hashtags-usage',
    template: componentNameToTemplate('sharePage'),
    data: {
      title: 'Connect | Hashtags Usage',
      navGroup: NavGroup.MEDIA,
      hasAccess: () => {
        return hasAllFeatures('share_v2') || !!crl8.session?.client.isShareV2Vendor;
      },
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.share',
        () => import('app/share/ShareApp'),
      ),
    },
  }),
};
